import config from './config';
import persistedState from './common/util/persistedState';
import persistedStorageMiddleware from './common/middleware/persistedStorageMiddleware';
import configureStore from './configureStore';
export var store = configureStore({
  extraMiddleware: [persistedStorageMiddleware()],
  inDevelopment: config.inDevelopment(),
  initialState: persistedState.load()
});
if (config.inDevelopment()) {
  window.store = store;
  window.getState = store.getState;
  window.dispatch = store.dispatch;
}
export function setFakeStore(fakeState) {
  store.useFakeState = true;
  store.fakeState = fakeState;
}
export function unsetFakeStore(fakeState) {
  store.useFakeState = false;
  store.fakeState = null;
}
store.getAppState = function () {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return store.useFakeState || opts.useFakeState ? store.fakeState : store.getState();
};
export default store;